import NiceModal, {NiceModalHocProps} from "@ebay/nice-modal-react";
import {Theme} from "@mui/material";
import {SxProps} from "@mui/system";
import React, {FunctionComponent, useCallback} from "react";
import {Text} from "../../../../ui";
import {PartnerDetails} from "../../../declarations";
import {termsAndConditionsMap, TermsType} from "./components";

export type TermsAndConditionsProps = {
  termsAndConditionsId?: string;
  page?: string;
  page_T_C: string;
  pageViewEvent: (event: any) => void;
  pageClickEvent: (event: any) => void;
  TermsAndConditionsDialog: FunctionComponent<any & NiceModalHocProps>;
  PaymentTermsAndConditionsV2: React.FC<{partnerDetails?: PartnerDetails}>;
  partnerDetails?: PartnerDetails;
  fpPartnerName?: string;
  sx?: SxProps<Theme>;
};

const TermsAndConditionsApproval = ({
  termsAndConditionsId = TermsType.PAYMENT,
  page,
  page_T_C,
  pageClickEvent,
  pageViewEvent,
  TermsAndConditionsDialog,
  PaymentTermsAndConditionsV2,
  partnerDetails,
  fpPartnerName,
  sx,
}: TermsAndConditionsProps) => {
  const termsAndConditionsHandler = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
      if (page) {
        pageClickEvent({page, cta: "t_c"});
      }
      event.preventDefault();
      NiceModal.show(TermsAndConditionsDialog, {
        PaymentTermsAndConditionsV2: <PaymentTermsAndConditionsV2 partnerDetails={partnerDetails} />,
        pageViewEvent,
        page: page_T_C,
      });
    },
    [page]
  );

  const getTermsAndConditionsContent = () => {
    const termsAndConditionFn = termsAndConditionsMap[termsAndConditionsId as string];
    if (!termsAndConditionFn) return termsAndConditionsId;
    return termsAndConditionFn(termsAndConditionsHandler, partnerDetails?.partnerName || fpPartnerName);
  };

  return (
    <Text size={12} sx={sx}>
      {getTermsAndConditionsContent()}
    </Text>
  );
};

export {TermsAndConditionsApproval};
